import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.promise.finally.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  methods: {
    enter: function enter(element) {
      element.style.width = getComputedStyle(element).width;
      element.style.position = 'absolute';
      element.style.visibility = 'hidden';
      element.style.height = 'auto';
      var height = getComputedStyle(element).height;
      element.style.width = null;
      element.style.position = null;
      element.style.visibility = null;
      element.style.height = 0; // Force repaint to make sure the animation is triggered correctly.
      // eslint-disable-next-line no-unused-expressions

      getComputedStyle(element).height; // Trigger the animation. We use `requestAnimationFrame` because we need to make sure the browser has finished
      // painting after setting the `height` to `0` in the line above.

      requestAnimationFrame(function () {
        element.style.height = height;
      });
    },
    afterEnter: function afterEnter(element) {
      element.style.height = 'auto';
    },
    leave: function leave(element) {
      element.style.height = getComputedStyle(element).height; // Force repaint to make sure the animation is triggered correctly.
      // eslint-disable-next-line no-unused-expressions

      getComputedStyle(element).height;
      requestAnimationFrame(function () {
        element.style.height = 0;
      });
    }
  }
};